import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, HttpHeadersService } from '@perval/shared';
import { firstValueFrom, map } from 'rxjs';
import { Credit } from '../models/credit';
import { fromPackHttpToPack, OffersHttp } from './mappers/pack-credit.mapper';

@Injectable({
  providedIn: 'root',
})
export class CreditService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-credits`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  async getAllPacks(): Promise<Credit.Pack[]> {
    return firstValueFrom(
      this.http
        .get<OffersHttp>(`${this.mainUrl}/offers`, {
          headers:
            await this.httpHeadersServiceService.getHeadersWithPervalContext(),
        })
        .pipe(map((packs) => packs.items.map(fromPackHttpToPack))),
    );
  }
}
